// beauty-bag-handler.js — Gratis beauty bag voor nieuwe klanten (NC)
// Flow: URL param ?gift=beauty-bag → cookie (30d) → auto-add bij cart ≥ €30 → popup
// Validatie nieuwe klant op checkout-niveau: Checkout UI Extension + Discount Function

(function () {
  const PARAM_KEY     = 'gift';
  const PARAM_VALUE   = 'beauty-bag';
  const COOKIE_KEY    = 'pb_beauty_bag_campaign';
  const SUPPRESS_KEY  = 'pb_beauty_bag_suppressed';
  const ATTR_KEY      = '_beauty_bag';
  const ATTR_VALUE    = 'true';
  const THRESHOLD     = 3000; // €30 in eurocent

  // --- Config ---

  function getVariantId() {
    return window.PB_BEAUTY_BAG?.variantId || null;
  }

  // --- Cookie helpers ---

  function setCampaignCookie() {
    const maxAge = 60 * 60 * 24 * 30;
    const parts = [
      COOKIE_KEY + '=1',
      'path=/',
      'max-age=' + maxAge,
      'SameSite=Lax'
    ];
    // Alleen het brede .planetb.care domein zetten als we daadwerkelijk op
    // een planetb.care host zitten — anders (preview/myshopify) faalt de cookie stil.
    if (/(^|\.)planetb\.care$/i.test(window.location.hostname)) {
      parts.splice(2, 0, 'domain=.planetb.care');
    }
    document.cookie = parts.join('; ');
  }

  function hasCampaignCookie() {
    return document.cookie.split('; ').some(function (c) {
      return c.startsWith(COOKIE_KEY + '=');
    });
  }

  // --- Sessie-suppressie (gebruiker verwijderde beauty bag → niet opnieuw toevoegen) ---

  function isSuppressed() {
    return sessionStorage.getItem(SUPPRESS_KEY) === '1';
  }

  // Exposed globally so cart-lines.js can call this when user removes the gift
  window.pbBeautyBagSuppress = function () {
    sessionStorage.setItem(SUPPRESS_KEY, '1');
  };

  // --- Subtotaalberekening (excl. gift cards, auto-gifts en beauty bag zelf) ---

  var EXCLUDED_PRODUCT_IDS = new Set([
    'gid://shopify/Product/4849416896586',   // Gift card
    'gid://shopify/Product/15652866294134',  // Membership
    'gid://shopify/Product/15630492238198',  // Membership
  ]);

  function qualifyingSubtotal(gqlCart) {
    var edges = (gqlCart && gqlCart.lines && gqlCart.lines.edges) || [];
    if (!edges.length) {
      return Math.round(parseFloat((gqlCart && gqlCart.cost && gqlCart.cost.subtotalAmount && gqlCart.cost.subtotalAmount.amount) || 0) * 100);
    }
    return Math.round(
      edges.reduce(function (sum, edge) {
        var node = edge.node;
        var pid = (node.merchandise && node.merchandise.product && node.merchandise.product.id) || '';
        if (EXCLUDED_PRODUCT_IDS.has(pid)) return sum;

        var attrs = node.attributes || [];
        if (attrs.some(function (a) { return a.key === '_auto_gift' && a.value === 'true'; })) return sum;
        if (attrs.some(function (a) { return a.key === ATTR_KEY && a.value === ATTR_VALUE; })) return sum;

        return sum + parseFloat((node.cost && node.cost.totalAmount && node.cost.totalAmount.amount) || 0);
      }, 0) * 100
    );
  }

  // --- Zoek beauty bag regel in cart ---

  function findBeautyBagLine(gqlCart) {
    var edges = (gqlCart && gqlCart.lines && gqlCart.lines.edges) || [];
    for (var i = 0; i < edges.length; i++) {
      var node = edges[i].node;
      var attrs = node.attributes || [];
      if (attrs.some(function (a) { return a.key === ATTR_KEY && a.value === ATTR_VALUE; })) {
        return node;
      }
    }
    return null;
  }

  // --- Popup ---

  function showPopup() {
    var popup = document.getElementById('BeautyBagPopup');
    if (!popup) return;
    popup.removeAttribute('hidden');
    popup.classList.add('bb-popup--visible');
    window.PBOverlayStack?.push(popup);
  }

  // --- Kern sync-logica ---

  var syncing = false;
  var timer;
  var popupShown = false;

  // Gebruik de cart uit het event indien aanwezig; val alleen op een eigen
  // refresh terug wanneer er geen cart meegegeven is. Dit voorkomt dubbele,
  // gelijktijdige refreshes (die PBCart een CONFLICT geven en een nieuwe
  // lege cart laten aanmaken).
  // De gift-handler geeft in zijn 'gifts'-event een cart mee van vóór zijn
  // mutatie (stale) — die negeren we en doen we een verse refresh. Voor alle
  // andere bronnen geeft PBCart de actuele cart mee, die we hergebruiken.
  function resolveCart(eventCart, src) {
    if (eventCart && eventCart.lines && src !== 'gifts') return Promise.resolve(eventCart);
    return window.PBCart.refresh();
  }

  function sync(eventCart, src) {
    if (!hasCampaignCookie()) return;
    if (isSuppressed()) return;

    var variantId = getVariantId();
    if (!variantId) return;

    if (syncing) return;
    syncing = true;

    resolveCart(eventCart, src)
      .then(function (cart) {
        var subtotal = qualifyingSubtotal(cart);
        var eligible  = subtotal >= THRESHOLD;
        var existing  = findBeautyBagLine(cart);

        if (eligible && !existing) {
          return window.PBCart.addLine(variantId, 1, [
            { key: ATTR_KEY, value: ATTR_VALUE }
          ]).then(function () {
            if (!popupShown) {
              showPopup();
              popupShown = true;
            }
            document.dispatchEvent(new CustomEvent('pb:cart:updated', {
              detail: { source: 'beauty_bag' }
            }));
          });
        }

        if (!eligible && existing) {
          return window.PBCart.removeLine(existing.id).then(function () {
            document.dispatchEvent(new CustomEvent('pb:cart:updated', {
              detail: { source: 'beauty_bag' }
            }));
          });
        }
      })
      .catch(function (err) {
        console.warn('[BeautyBag] sync error', err);
      })
      .finally(function () {
        syncing = false;
      });
  }

  // 260ms > de 180ms van cart-gift-handler, zodat die zijn mutatie eerst afrondt
  // en we niet gelijktijdig op dezelfde cart muteren.
  function schedule(eventCart, src) {
    clearTimeout(timer);
    timer = setTimeout(function () { sync(eventCart, src); }, 260);
  }

  // --- Initialisatie ---

  // 1. Detecteer URL param → zet cookie
  (function detectParam() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get(PARAM_KEY) === PARAM_VALUE) {
        setCampaignCookie();
      }
    } catch (_) {}
  })();

  // 2. Sync bij laden (eigen refresh nodig — nog geen event-cart)
  document.addEventListener('DOMContentLoaded', function () { schedule(); });

  // 3. Sync na elke cart-update; hergebruik de meegegeven cart om dubbele
  //    refreshes te vermijden. Negeer alleen onze eigen mutaties.
  document.addEventListener('pb:cart:updated', function (e) {
    var src = (e.detail && e.detail.source) || '';
    if (src === 'beauty_bag') return;
    schedule(e.detail && e.detail.cart, src);
  });
})();
